export default {
  name: "Phone",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M23.98 3.12c-1.18-.31-2.24.18-2.88 1.33-1.05 1.73-1.76 2.44-2.79 4.19-.38.6-.5 1.2-.36 1.76.25.96 1.15 1.46 1.95 1.9.46.25 1.02.56 1.15.82.25.49-.54 2.37-3.01 4.85-2.47 2.47-4.35 3.26-4.85 3.01-.26-.13-.57-.7-.82-1.15-.44-.8-.94-1.7-1.9-1.95a2.15 2.15 0 0 0-1.75.35c-.9.55-3.34 2.3-4.16 2.78-1.22.67-1.75 1.75-1.44 2.97.66 2.58 4.96 5.01 7.82 5.01 4.16 0 7.86-1.85 12.01-5.99s5.99-7.85 5.99-12.01c.01-2.88-2.4-7.2-4.96-7.87zm-2.44 18.44c-3.74 3.74-7.01 5.41-10.59 5.41-2.31 0-5.53-2.12-5.88-3.5-.04-.17-.11-.42.48-.74.92-.54 3.38-2.3 4.23-2.82l.19-.11c.17.11.47.65.65.98.4.74.86 1.57 1.68 1.98 2.19 1.1 5.42-1.65 7.15-3.39 1.73-1.73 4.48-4.97 3.39-7.15-.41-.82-1.24-1.28-1.98-1.68a4.6 4.6 0 0 1-.97-.61s.01-.07.12-.25c1.03-1.74 1.72-2.42 2.81-4.22.29-.51.49-.45.65-.41 1.34.35 3.48 3.64 3.48 5.92 0 3.59-1.67 6.85-5.41 10.59z",
  },
}
